var map = {
	"./ai-logic.svg": "7bb8",
	"./api-task.svg": "68f5",
	"./code-task.svg": "51ba",
	"./condition-task.svg": "13b1",
	"./database-task.svg": "d4fb",
	"./email-task.svg": "318d",
	"./end-task.svg": "a9b7",
	"./get-item-task.svg": "0892",
	"./gpt-task.svg": "c555",
	"./json-mapper-task.svg": "097f",
	"./logic-task.svg": "51d9",
	"./page-task.svg": "a654",
	"./redirect-task.svg": "abe3",
	"./remove-item-task.svg": "1e85",
	"./report-task.svg": "27e3",
	"./start-task.svg": "10bc",
	"./update-item-task.svg": "9d2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5dfd";